<div>
  <h2>Add new group</h2>
  <br />
  <p class="apply-template">
    <a (click)="applyTemplate(); $event.stopPropagation()">Choose a Template</a>
  </p>

  <form [formGroup]="form">
    <div class="form-group">
      <label for="name">Enter a group name</label>
      <input type="text" class="form-control" formControlName="name" [ngClass]="getValidationClass('name')" />
      <p *ngIf="form.get('name').invalid && form.get('name').getError('flagGroupExists')" class="text-danger">
        This group already exists
      </p>
    </div>
  </form>

  <div>
    <button type="button" class="btn aru btn-primary" (click)="save()" [disabled]="saving || form.invalid">
      Create group
    </button>
    &nbsp;
    <button type="button" class="btn aru btn-ghost-danger" (click)="cancel.emit()">Cancel</button>
  </div>
</div>

<app-flag-group-template
  #flagGroupTemplateModal
  [group]="this.form.value"
  [inspectionId]="inspection.id"
  [flagGroupTags]="flagGroupTags"
  [createGroup]="true"
  [expand]="false"
  (messageEvent)="updateData($event)"></app-flag-group-template>
